var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Original_Colored_Outline_copy",
    viewBox: "0 0 1859.129 2950",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m929.217 2949.998c-12.811-.121-24.639-6.906-31.215-17.901-561.992-939.662-898.002-1476.611-898.002-2000.221 0-503.827 415.596-931.876 928.259-931.876h1.291.03 1.291c512.663 0 928.259 428.049 928.259 931.876 0 523.609-336.01 1060.558-898.002 2000.22-6.704 11.208-18.852 18.026-31.911 17.902z",
    fill: "#f71959"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 930.871,
    cy: 938.496,
    fill: "#fffaf3",
    r: 524.344
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/locationPin.1b6f9d67ca539d9d600a332eb354343f.svg";
export { ForwardRef as ReactComponent };